<span *ngIf="currentUser && !currentUser.isAuthenticated">
  <a class="login-link" href="/app/DoLogin">Sign in</a>
</span>
<span *ngIf="currentUser && currentUser.isAuthenticated">
    <span title="{{currentUser.email}}">
        {{ currentUser.firstName }} {{ currentUser.lastName }}
    </span>
  <a class="logout-link d-block d-lg-inline" href="/app/Logout">Sign out</a>
</span>
